export const PriceListVersionOptions = {
    InheritFromActive: 'inherit-from-active',
    InheritFromAnother: 'inherit-from-another',
    BlankVersion: 'blank-version'
};